module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AW-6534ebc4e5019dcada929943f9ef2c1a.png";